import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Redirecting to <a href="https://au.linkedin.com/in/alvet">https://au.linkedin.com/in/alvet </a>
        </p>
      </header>
    </div>
  );
}

export default App;
